import {
  AuthActions,
  useActionResult,
  useLocalePath,
} from "@commercekit/remix";
import { useEffect } from "react";
import { useErrorAlert } from "@commercekit/react";

export const useLogin = () => {
  const localePath = useLocalePath();
  const { show } = useErrorAlert();
  const { error } = useActionResult({
    action: localePath("/login"),
    _action: AuthActions.LOGIN,
  });
  useEffect(() => {
    if (error) {
      show(error.join(","), "danger");
    }
  }, [error, show]);
};
